<template>
  <transition name="fade">
    <div v-if="isLoading" class="global-loading-overlay" @click.prevent>
      <div class="loading-content">
        <div class="loader mx-auto"></div>
        <p class="loading-text">{{ loadingMessage }}</p>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'GlobalLoadingOverlay',
  data() {
    return {
      safetyTimeout: null,
      maxLoadingTime: 30000, // 30 seconds max
      showReloadPrompt: false
    };
  },
  computed: {
    isLoading() {
      return this.$store.getters.isGlobalLoading;
    },
    loadingMessage() {
      const states = this.$store.state.loadingStates;
      if (states.initializing) return 'Initializing...';
      if (states.authenticating) return 'Loading user data...';
      if (states.navigating) return 'Loading...';
      return 'Loading...';
    }
  },
  watch: {
    isLoading(newVal) {
      if (newVal) {
        this.startSafetyTimeout();
      } else {
        this.clearSafetyTimeout();
      }
    }
  },
  methods: {
    startSafetyTimeout() {
      this.clearSafetyTimeout();
      this.safetyTimeout = setTimeout(() => {
        console.error('⚠️ Loading timeout - app may be stuck');
        // Show reload prompt instead of just hiding
        this.showReloadPrompt = true;
        this.promptReload();
      }, this.maxLoadingTime);
    },
    promptReload() {
      if (this.$swal) {
        this.$swal({
          title: 'Loading Timeout',
          text: 'The page is taking too long to load. Would you like to reload?',
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'Reload Now',
          cancelButtonText: 'Wait Longer',
          confirmButtonColor: '#e7515a',
          cancelButtonColor: '#4361ee'
        }).then((result) => {
          if (result.isConfirmed) {
            // Reload the page completely
            window.location.reload();
          } else {
            // User chose to wait - extend timeout
            this.showReloadPrompt = false;
            this.startSafetyTimeout();
          }
        });
      } else {
        // Fallback if SweetAlert not available
        if (confirm('The page is taking too long to load. Reload now?')) {
          window.location.reload();
        } else {
          this.showReloadPrompt = false;
          this.startSafetyTimeout();
        }
      }
    },
    clearSafetyTimeout() {
      if (this.safetyTimeout) {
        clearTimeout(this.safetyTimeout);
        this.safetyTimeout = null;
      }
    }
  },
  beforeDestroy() {
    this.clearSafetyTimeout();
  }
};
</script>

<style scoped>
.global-loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.98);
  z-index: 99999;
  display: flex;
  align-items: center;
  justify-content: center;
  backdrop-filter: blur(2px);
}

.loading-content {
  text-align: center;
  padding: 40px;
}

.loading-text {
  margin-top: 20px;
  color: #4361ee;
  font-size: 16px;
  font-weight: 500;
}

/* Smooth transitions */
.fade-enter-active, .fade-leave-active {
  transition: opacity 0.2s;
}

.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>

